import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { RegoLookupActions } from '../constants/rego_lookup/rego_lookup_actions';
import { Filters } from '../constants/filter/filters';
import { getDefaultValueForFilter } from '../helper/filters/get_default_value_for_filter';
import { isNzStore } from '../../_views/configurator/common';
import { forOwn } from '../../../lib/utilities';

class RegoLookupStoreClass extends ReduceStore {

    getInitialState() {
        const values = {};
        values[Filters.POSTCODE] = getDefaultValueForFilter(Filters.POSTCODE);
        values[Filters.REGISTRATION] = getDefaultValueForFilter(Filters.REGISTRATION);
        values[Filters.VEHICLE_ID] = '';
        values[Filters.VEHICLE_MAKE] = '';
        values[Filters.VEHICLE_MODEL] = '';
        values[Filters.VEHICLE_DETAILS] = '';
        values[Filters.VEHICLE_ENGINE] = '';
        values[Filters.VEHICLE_SERIES] = '';
        values[Filters.VEHICLE_CHASSIS] = '';
        values[Filters.VEHICLE_ENGINE_DETAILS] = '';
        values[Filters.VEHICLE_YEAR_RANGE_FROM] = '';
        values[Filters.VEHICLE_YEAR_RANGE_TO] = '';
        values[Filters.VEHICLE_COUNTRY_OF_ORIGIN] = '';
        values[Filters.VEHICLE_VIN] = '';
        values[Filters.VEHICLE_TYRES] = getDefaultValueForFilter(Filters.VEHICLE_TYRES);
        values[Filters.VEHICLE_STATE] = getDefaultValueForFilter(Filters.VEHICLE_STATE);
        values[Filters.VEHICLE_NOT_PROVIDED_COMMENT] = '';
        values[Filters.TYRE_OPTIONS] = [];

        let inputStateVisible = true;
        if (isNzStore(TYROOLA.globals.store)) {
            inputStateVisible = false;
            values[Filters.VEHICLE_STATE] = 'NZ';
        }

        const vehicleData = [];
        return {
            visible: false,
            visibleV2: false,
            fromTyreSize: false,
            inputStateVisible: inputStateVisible,
            inputLayerVisible: true,
            confirmationLayerVisible: false,
            vehicleNotProvidedLayerVisible: false,
            postcodeInvalidMessage: false,
            registrationInvalidMessage: false,
            licenceNotFound: false,
            buttonContinueDisabled: false,
            buttonConfirmDisabled: true,
            showTyres: false,
            buttonConfirmIsShown: true,
            tyreOptions: [],
            stateOptions: [
                ['ACT', 'ACT'],
                ['NT', 'NT'],
                ['SA', 'SA'],
                ['WA', 'WA'],
                ['NSW', 'NSW'],
                ['QLD', 'QLD'],
                ['VIC', 'VIC'],
                ['TAS', 'TAS'],
            ],
            values,
            vehicleData,
            postcodeSuggestion: null,
            touched: false,
            infoLayerVisible: false,
        };
    }

    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.REGO_LOOKUP_ACTION) {
            switch (action.type) {
                case RegoLookupActions.SHOW_ACTION:
                    if (!state.visible) {
                        state.visible = true;
                        state.visibleV2 = false;
                        state.fromTyreSize = false;
                        this.__emitChange();
                    }

                    break;

                case RegoLookupActions.SHOW_ACTION_V2:
                    if (!state.visibleV2) {
                        state.visibleV2 = true;
                        state.visible = true;
                        state.fromTyreSize = action.payload;
                        this.__emitChange();
                    }

                    break;

                case RegoLookupActions.HIDE_ACTION:
                    if (state.visible) {
                        state.visible = false;
                        state.visibleV2 = false;
                        state.fromTyreSize = false;
                        this.__emitChange();
                    }

                    break;
                case RegoLookupActions.SHOW_INPUT_LAYER:
                    if (!state.inputLayerVisible) {
                        state.inputLayerVisible = true;
                        this.__emitChange();
                    }

                    break;
                case RegoLookupActions.HIDE_INPUT_LAYER:
                    if (state.inputLayerVisible) {
                        state.inputLayerVisible = false;
                        this.__emitChange();
                    }

                    break;
                case RegoLookupActions.SHOW_CONFIRMATION_LAYER:
                    if (!state.confirmationLayerVisible) {
                        state.confirmationLayerVisible = true;
                        this.__emitChange();
                    }

                    break;
                case RegoLookupActions.HIDE_CONFIRMATION_LAYER:
                    if (state.confirmationLayerVisible) {
                        state.confirmationLayerVisible = false;
                        this.__emitChange();
                    }

                    break;

                case RegoLookupActions.SHOW_VEHICLE_NOT_PROVIDED_LAYER:
                    if (!state.vehicleNotProvidedLayerVisible) {
                        state.vehicleNotProvidedLayerVisible = true;
                        this.__emitChange();
                    }

                    break;
                case RegoLookupActions.HIDE_VEHICLE_NOT_PROVIDED_LAYER:
                    if (state.vehicleNotProvidedLayerVisible) {
                        state.vehicleNotProvidedLayerVisible = false;
                        this.__emitChange();
                    }

                    break;
                case RegoLookupActions.SET_STATE:
                    if (state.values[Filters.VEHICLE_STATE] !== action.payload) {
                        state.values[Filters.VEHICLE_STATE] = action.payload;
                        state.touched = true;
                        this.__emitChange();
                    }

                    break;
                case RegoLookupActions.SET_VEHICLE_NOT_PROVIDED_COMMENT:
                    if (state.values[Filters.VEHICLE_NOT_PROVIDED_COMMENT] !== action.payload) {
                        state.values[Filters.VEHICLE_NOT_PROVIDED_COMMENT] = action.payload;
                        state.touched = true;
                        this.__emitChange();
                    }

                    break;
                case RegoLookupActions.SET_POSTCODE:
                    if (state.values[Filters.POSTCODE] !== action.payload) {
                        state.values[Filters.POSTCODE] = action.payload;
                        this.__emitChange();
                    }

                    break;
                case RegoLookupActions.SET_REGISTRATION:
                    if (state.values[Filters.REGISTRATION] !== action.payload) {
                        state.values[Filters.REGISTRATION] = action.payload;
                        this.__emitChange();
                    }

                    break;
                case RegoLookupActions.SHOW_POSTCODE_INVALID:
                    if (!state.postcodeInvalidMessage) {
                        state.postcodeInvalidMessage = true;
                        this.__emitChange();
                    }
                    break;
                case RegoLookupActions.HIDE_POSTCODE_INVALID:
                    if (state.postcodeInvalidMessage) {
                        state.postcodeInvalidMessage = false;
                        this.__emitChange();
                    }
                    break;
                case RegoLookupActions.SHOW_REGISTRATION_INVALID:
                    if (!state.registrationInvalidMessage) {
                        state.registrationInvalidMessage = true;
                        this.__emitChange();
                    }
                    break;
                case RegoLookupActions.HIDE_REGISTRATION_INVALID:
                    if (state.registrationInvalidMessage) {
                        state.registrationInvalidMessage = false;
                        this.__emitChange();
                    }
                    break;
                case RegoLookupActions.SHOW_LICENCE_NOT_FOUND:
                    if (!state.licenceNotFound) {
                        state.licenceNotFound = true;
                        this.__emitChange();
                    }
                    break;
                case RegoLookupActions.HIDE_LICENCE_NOT_FOUND:
                    if (state.licenceNotFound) {
                        state.licenceNotFound = false;
                        this.__emitChange();
                    }
                    break;
                case RegoLookupActions.DISABLE_BUTTON_CONTINUE:
                    if (!state.buttonContinueDisabled) {
                        state.buttonContinueDisabled = true;
                        this.__emitChange();
                    }
                    break;
                case RegoLookupActions.ENABLE_BUTTON_CONTINUE:
                    if (state.buttonContinueDisabled) {
                        state.buttonContinueDisabled = false;
                        this.__emitChange();
                    }
                    break;
                case RegoLookupActions.DISABLE_BUTTON_CONFIRM:
                    if (!state.buttonConfirmDisabled) {
                        state.buttonConfirmDisabled = true;
                        this.__emitChange();
                    }
                    break;
                case RegoLookupActions.ENABLE_BUTTON_CONFIRM:
                    if (state.buttonConfirmDisabled) {
                        state.buttonConfirmDisabled = false;
                        this.__emitChange();
                    }
                    break;
                case RegoLookupActions.SET_TYRE_OPTIONS:
                    state.tyreOptions = action.payload;
                    this.__emitChange();
                    break;
                case RegoLookupActions.SET_TYRE:
                    if (state.values[Filters.VEHICLE_TYRES] !== action.payload) {
                        state.values[Filters.VEHICLE_TYRES] = action.payload;
                        this.__emitChange();
                    }
                    break;
                case RegoLookupActions.SHOW_TYRES:
                    if (!state.showTyres) {
                        state.showTyres = true;
                        this.__emitChange();
                    }
                    break;
                case RegoLookupActions.HIDE_TYRES:
                    if (state.showTyres) {
                        state.showTyres = false;
                        this.__emitChange();
                    }
                    break;
                case RegoLookupActions.SHOW_CONFIRM_BUTTON:
                    if (!state.buttonConfirmIsShown) {
                        state.buttonConfirmIsShown = true;
                        this.__emitChange();
                    }
                    break;
                case RegoLookupActions.HIDE_CONFIRM_BUTTON:
                    if (state.buttonConfirmIsShown) {
                        state.buttonConfirmIsShown = false;
                        this.__emitChange();
                    }
                    break;
                case RegoLookupActions.SET_VEHICLE_DATA:
                    state.vehicleData = action.payload;
                    break;
                case RegoLookupActions.SET_POSTCODE_SUGGESTION:
                    state.postcodeSuggestion = action.payload;
                    state.postcodeInvalidMessage = false;
                    this.__emitChange();
                    break;
                case RegoLookupActions.SHOW_INFO_LAYER:
                    state.infoLayerVisible = true;
                    this.__emitChange();
                    break;
                case RegoLookupActions.HIDE_INFO_LAYER:
                    state.infoLayerVisible = false;
                    this.__emitChange();
                    break;
                case RegoLookupActions.SET_VALUES:
                    let change = false;
                    forOwn(action.payload, (value, key) => {
                        if (typeof state.values[key] !== 'undefined' && action.payload[key] !== state.values[key]) {
                            if (typeof action.payload[key] == 'string') {
                                state.values[key] = action.payload[key].trim();
                            } else {
                                state.values[key] = action.payload[key];
                            }
                            change = true;
                        }
                    });

                    if (change) {
                        this.__emitChange();
                    }
                    break;
                case RegoLookupActions.RESET_VALUES:
                    state = this.getInitialState();
                    this.__emitChange();
                    break;
            }
        }

        return state;
    }
}

const RegoLookupStore = new RegoLookupStoreClass(Dispatcher);
export default RegoLookupStore;
